import { RegistrationData } from "app/types/registrationTypes";

export const SESSION_TOKEN = "session-token";
export const REGEX_VS: RegExp = / vs | at | 对 | v /g;

/**
 * Navigation types
 * */
export const NavigationMetaTypes = {
  SPORT: "SPORT",
  COUNTRY: "COUNTRY",
  COMPETITION: "COMPETITION",
};

/**
 * Bet slip states
 * */
export const BetSlipStates = {
  PENDING: "PENDING",
  FAILED: "FAILED",
  FINISHED: "FINISHED",
  PROCESSING: "PROCESSING",
};

/**
 * Bet slip states
 * */
export const BetSlipPlacementStates = {
  IN_PLAY: "IN_PLAY",
  LIVE_MATCH_INCIDENTS: "LIVE_MATCH_INCIDENTS",
  MARKET_ODDS: "MARKET_ODDS",
};

/**
 * Bet Builder states
 * */
export const BetBuilderStates = {
  OPEN: "OPEN",
  LIVE: "LIVE",
  UNAVAILABLE: "UNAVAILABLE",
  REDUNDANT_LEG: "REDUNDANT_LEG",
};

/**
 * Danger zone states
 * */
export const DangerZoneStates = {
  SAFE: "SAFE",
  HOME_GOAL: "HOME_GOAL",
  AWAY_GOAL: "AWAY_GOAL",
  HOME_PENALTY: "HOME_PENALTY",
  AWAY_PENALTY: "AWAY_PENALTY",
  HOME_DANGEROUS_FREEKICK: "HOME_DANGEROUS_FREEKICK",
  AWAY_DANGEROUS_FREEKICK: "AWAY_DANGEROUS_FREEKICK",
  HOME_ATTACKING_FREEKICK: "HOME_ATTACKING_FREEKICK",
  AWAY_ATTACKING_FREEKICK: "AWAY_ATTACKING_FREEKICK",
  HOME_DANGEROUS_ATTACK: "HOME_DANGEROUS_ATTACK",
  AWAY_DANGEROUS_ATTACK: "AWAY_DANGEROUS_ATTACK",
  HOME_CORNER: "HOME_CORNER",
  AWAY_CORNER: "AWAY_CORNER",
  HOME_CORNER_DANGER: "HOME_CORNER_DANGER",
  AWAY_CORNER_DANGER: "AWAY_CORNER_DANGER",
  MISSED_INCIDENT: "MISSED_INCIDENT",
  POSSIBLE_VAR: "POSSIBLE_VAR",
  POSSIBLE_VAR_CANCELLED: "POSSIBLE_VAR_CANCELLED",
  AWAY_VAR: "AWAY_VAR",
  AWAY_END_VAR: "AWAY_END_VAR",
  HOME_VAR: "HOME_VAR",
  HOME_END_VAR: "HOME_END_VAR",
};

/**
 * Incident type states
 * */
export const IncidentTypeStates = {
  HOME_GOAL: "HOME_GOAL",
  AWAY_GOAL: "AWAY_GOAL",
  HOME_CORNER: "HOME_CORNER",
  AWAY_CORNER: "AWAY_CORNER",
  HOME_YELLOW_CARD: "HOME_YELLOW_CARD",
  AWAY_YELLOW_CARD: "AWAY_YELLOW_CARD",
  HOME_RED_CARD: "HOME_RED_CARD",
  AWAY_RED_CARD: "AWAY_RED_CARD",
  HOME_SUB: "HOME_SUB",
  AWAY_SUB: "AWAY_SUB",
  GAME_COMPLETE: "GAME_COMPLETE",
  SET_COMPLETE: "SET_COMPLETE",
  MATCH_COMPLETE: "MATCH_COMPLETE",
};

/**
 * Market Periods
 */
export const MarketPeriods = Object.freeze({
  COMPLETE_EVENT: "COMPLETE_EVENT",
  EXTRA_TIME: "EXTRA_TIME",
  BEFORE_EXTRA_TIME: "BEFORE_EXTRA_TIME",
  FULL_EVENT: "FULL_EVENT",
  FIRST_HALF: "FIRST_HALF",
  SECOND_HALF: "SECOND_HALF",
  FIRST_QUARTER: "FIRST_QUARTER",
  SECOND_QUARTER: "SECOND_QUARTER",
  THIRD_QUARTER: "THIRD_QUARTER",
  FOURTH_QUARTER: "FOURTH_QUARTER",
  FIRST_FIVE_INNINGS: "FIRST_FIVE_INNINGS",
  FIRST_PERIOD: "FIRST_PERIOD",
  SECOND_PERIOD: "SECOND_PERIOD",
  THIRD_PERIOD: "THIRD_PERIOD",
  FOURTH_PERIOD: "FOURTH_PERIOD",
  REGULATION_TIME: "REGULATION_TIME",
  MAP_1: "MAP_1",
  MAP_2: "MAP_2",
  MAP_3: "MAP_3",
  MAP_4: "MAP_4",
  MAP_5: "MAP_5",
});

/**
 * Market types
 * */
export const MarketTypes = {
  TOTAL_CARDS_AWAY: "TOTAL_CARDS_AWAY",
  TOTAL_CARDS: "TOTAL_CARDS",
  TOTAL_CARDS_HOME: "TOTAL_CARDS_HOME",
  FIRST_CARDED_TEAM: "FIRST_CARDED_TEAM",
  PLAYER_TOTAL_GOALS_ROLLING: "PLAYER_TOTAL_GOALS_ROLLING",
  PLAYER_TOTAL_SHOTS_ROLLING: "PLAYER_TOTAL_SHOTS_ROLLING",
  PLAYER_TOTAL_ASSISTS_ROLLING: "PLAYER_TOTAL_ASSISTS_ROLLING",
  PLAYER_TOTAL_POINTS_ROLLING: "PLAYER_TOTAL_POINTS_ROLLING",
  PLAYER_TOTAL_BLOCKS_ROLLING: "PLAYER_TOTAL_BLOCKS_ROLLING",
  PLAYER_TOTAL_STEALS_ROLLING: "PLAYER_TOTAL_STEALS_ROLLING",
  PLAYER_TOTAL_REBOUNDS_ROLLING: "PLAYER_TOTAL_REBOUNDS_ROLLING",
  DRAW_NO_BET: "DRAW_NO_BET",
  FULL_CORNERS: "FULL_CORNERS",
  HANDICAP: "HANDICAP",
  ASIAN_HANDICAP: "ASIAN_HANDICAP",
  ONE_X_TWO: "ONE_X_TWO",
  TOTAL: "TOTAL",
  MONEY_LINE: "MONEY_LINE",
  SET_HANDICAP: "SET_HANDICAP",
  SET_TOTAL: "SET_TOTAL",
  MATCH_ODDS: "MATCH_ODDS",
  MATCH_ODDS_THREE_WAY: "MATCH_ODDS_THREE_WAY",
  EXCHANGE_MARKETS: "EXCHANGE_MARKETS",
  // Display Type 1
  TOTAL_HOME: "TOTAL_HOME",
  TOTAL_AWAY: "TOTAL_AWAY",
  TOTAL_GOALS_HOME: "TOTAL_GOALS_HOME",
  TOTAL_GOALS_AWAY: "TOTAL_GOALS_AWAY",
  TOTAL_POINTS_HOME: "TOTAL_POINTS_HOME",
  TOTAL_POINTS_AWAY: "TOTAL_POINTS_AWAY",
  // Display Type 4
  CORRECT_SCORE: "CORRECT_SCORE",
  // Display Type 3
  WINNING_MARGIN: "WINNING_MARGIN",
  THREE_WAY_AND_TOTAL: "THREE_WAY_AND_TOTAL",
  THREE_WAY: "THREE_WAY",
  THREE_WAY_AND_BOTH_SCORE: "THREE_WAY_AND_BOTH_SCORE",
  HALF_TIME_RESULT_AND_BOTH_TEAMS_TO_SCORE:
    "HALF_TIME_RESULT_AND_BOTH_TEAMS_TO_SCORE",
  FIRST_LAST_GOAL: "FIRST_LAST_GOAL",
  LAST_GOAL: "LAST_GOAL",
  FIRST_GOAL: "FIRST_GOAL",
  NO_GOAL: "NO_GOAL",
  CORNER_TOTAL: "CORNER_TOTAL",
  CORNER_HANDICAP: "CORNER_HANDICAP",
  CORNER_ASIAN_HANDICAP: "CORNER_ASIAN_HANDICAP",
  CORNER_MONEY_LINE: "CORNER_MONEY_LINE",
  CORNER_ONE_X_TWO: "CORNER_ONE_X_TWO",
  // Display Type 6
  TOTAL_ODD_EVEN: "TOTAL_ODD_EVEN",
  TOTAL_ODD_EVEN_HOME: "TOTAL_ODD_EVEN_HOME",
  TOTAL_ODD_EVEN_AWAY: "TOTAL_ODD_EVEN_AWAY",
  CLEAN_SHEET: "CLEAN_SHEET",
  WIN_TO_NIL: "WIN_TO_NIL",
  BOTH_SCORE: "BOTH_SCORE",
  BOTH_SCORE_AND_TOTAL: "BOTH_SCORE_AND_TOTAL",
  FIGHT_GOES_DISTANCE: "FIGHT_GOES_DISTANCE",
  METHOD_OF_VICTORY: "METHOD_OF_VICTORY",
  MATCH_TIE: "MATCH_TIE",
  // Display Type 7
  RACE_TO: "RACE_TO",
  WINNER_INTERVAL: "WINNER_INTERVAL",
  WINNER_INTERVAL_1_15: "WINNER_INTERVAL_1_15",
  WINNER_INTERVAL_16_30: "WINNER_INTERVAL_16_30",
  WINNER_INTERVAL_31_45: "WINNER_INTERVAL_31_45",
  WINNER_INTERVAL_46_60: "WINNER_INTERVAL_46_60",
  WINNER_INTERVAL_61_75: "WINNER_INTERVAL_61_75",
  WINNER_INTERVAL_76_90: "WINNER_INTERVAL_76_90",
  HALF_MOST_GOALS: "HALF_MOST_GOALS",
  DOUBLE_CHANCE: "DOUBLE_CHANCE",
  HALF_FULL_TIME: "HALF_FULL_TIME",
  EXTRA_TIME_HALF: "EXTRA_TIME_HALF",

  GOALSCORER_LAST: "GOALSCORER_LAST",
  GOALSCORER_ANYTIME: "GOALSCORER_ANYTIME",
  GOALSCORER_1ST: "GOALSCORER_1ST",
  GOALSCORER_2ND: "GOALSCORER_2ND",
  GOALSCORER_3RD: "GOALSCORER_3RD",
  GOALSCORER_4TH: "GOALSCORER_4TH",
  GOALSCORER_5TH: "GOALSCORER_5TH",
  GOALSCORER_6TH: "GOALSCORER_6TH",
  GOALSCORER_7TH: "GOALSCORER_7TH",
  GOALSCORER_8TH: "GOALSCORER_8TH",
  GOALSCORER_9TH: "GOALSCORER_9TH",
  GOALSCORER_10TH: "GOALSCORER_10TH",
  GOALSCORER_11TH: "GOALSCORER_11TH",
  GOALSCORER_12TH: "GOALSCORER_12TH",
  GOALSCORER_13TH: "GOALSCORER_13TH",
  GOALSCORER_14TH: "GOALSCORER_14TH",
  GOALSCORER_15TH: "GOALSCORER_15TH",

  OUTRIGHT: "OUTRIGHT",

  // Display Type 8
  TOTAL_GOALS: "TOTAL_GOALS_RANGE",
  OVERTIME: "OVERTIME",
  HIGHEST_SCORING_QUARTER: "HIGHEST_SCORING_QUARTER",
  TEAM_HIGHEST_SCORING_QUARTER: "TEAM_HIGHEST_SCORING_QUARTER",
  HIGHEST_SCORING_QUARTER_AND_TEAM: "HIGHEST_SCORING_QUARTER_AND_TEAM",
  TOUCHDOWN_SCORED: "TOUCHDOWN_SCORED",
  TOTAL_TOUCHDOWNS: "TOTAL_TOUCHDOWNS",
  TOUCHDOWN_TEAM_SCORER_1ST: "TOUCHDOWN_TEAM_SCORER_1ST",
  TOUCHDOWN_TEAM_SCORER_2ND: "TOUCHDOWN_TEAM_SCORER_2ND",
  TOUCHDOWN_TEAM_SCORER_3RD: "TOUCHDOWN_TEAM_SCORER_3RD",
  TOUCHDOWN_TEAM_SCORER_4TH: "TOUCHDOWN_TEAM_SCORER_4TH",
  TOUCHDOWN_TEAM_SCORER_5TH: "TOUCHDOWN_TEAM_SCORER_5TH",
  TOUCHDOWN_TEAM_SCORER_6TH: "TOUCHDOWN_TEAM_SCORER_6TH",
  TOUCHDOWN_TEAM_SCORER_7TH: "TOUCHDOWN_TEAM_SCORER_7TH",
  TOUCHDOWN_TEAM_SCORER_8TH: "TOUCHDOWN_TEAM_SCORER_8TH",
  TOUCHDOWN_TEAM_SCORER_9TH: "TOUCHDOWN_TEAM_SCORER_9TH",
  TOUCHDOWN_TEAM_SCORER_10TH: "TOUCHDOWN_TEAM_SCORER_10TH",

  // HALF_FULL_TIME: "HALF_FULL_TIME", already added as Type 7 - check this
  LAST_POINT: "LAST_POINT",
  MONEYLINE_AND_TOTAL: "MONEYLINE_AND_TOTAL",
  WINNER_OF_TIE: "WINNER_OF_TIE",

  TOTAL_ROUNDS_COMPLETED: "TOTAL_ROUNDS_COMPLETED",
  ROUND_BETTING: "ROUND_BETTING",
  // misc display types for esports
  HANDICAP_KILLS: "HANDICAP_KILLS",
  TOTAL_KILLS: "TOTAL_KILLS",
  MOST_KILLS: "MOST_KILLS",
  TOTAL_KILLS_HOME: "TOTAL_KILLS_HOME",
  TOTAL_KILLS_AWAY: "TOTAL_KILLS_AWAY",

  // Player props
  PLAYER_SCORE_OUTSIDE_AREA: "PLAYER_SCORE_OUTSIDE_AREA",
  PLAYER_ASSISTS: "PLAYER_ASSISTS",
  PLAYER_ASSISTS_2_PLUS: "PLAYER_ASSISTS_2_PLUS",
  PLAYER_SCORE_AND_ASSIST: "PLAYER_SCORE_AND_ASSIST",
  PLAYER_SCORE_FREEKICK: "PLAYER_SCORE_FREEKICK",
  PLAYER_SCORE_HEADER: "PLAYER_SCORE_HEADER",
  BOTH_PLAYERS_SCORE: "BOTH_PLAYERS_SCORE",
  PLAYER_SHOWN_CARD: "PLAYER_SHOWN_CARD",
  PLAYER_SHOWN_RED_CARD: "PLAYER_SHOWN_RED_CARD",
  // NFL Player Props
  PLAYER_TOTAL_RUSHING_YARDS_ROLLING: "PLAYER_TOTAL_RUSHING_YARDS_ROLLING",
  PLAYER_TOTAL_RUSHING_ATTEMPTS_ROLLING:
    "PLAYER_TOTAL_RUSHING_ATTEMPTS_ROLLING",
  PLAYER_TOTAL_RECEIVING_YARDS_ROLLING: "PLAYER_TOTAL_RECEIVING_YARDS_ROLLING",
  PLAYER_TOTAL_RECEPTIONS_ROLLING: "PLAYER_TOTAL_RECEPTIONS_ROLLING",
  PLAYER_TOTAL_PASSING_YARDS_ROLLING: "PLAYER_TOTAL_PASSING_YARDS_ROLLING",
  PLAYER_TOTAL_PASSING_ATTEMPTS_ROLLING:
    "PLAYER_TOTAL_PASSING_ATTEMPTS_ROLLING",
  PLAYER_TOTAL_PASS_COMPLETIONS_ROLLING:
    "PLAYER_TOTAL_PASS_COMPLETIONS_ROLLING",
  PLAYER_TOTAL_PASSING_TOUCHDOWNS_ROLLING:
    "PLAYER_TOTAL_PASSING_TOUCHDOWNS_ROLLING",
  TOUCHDOWN_SCORER_ANYTIME: "TOUCHDOWN_SCORER_ANYTIME",
  TOUCHDOWN_SCORER_1ST: "TOUCHDOWN_SCORER_1ST",
  TOUCHDOWN_SCORER_2ND: "TOUCHDOWN_SCORER_2ND",
  TOUCHDOWN_SCORER_3RD: "TOUCHDOWN_SCORER_3RD",
  TOUCHDOWN_SCORER_4TH: "TOUCHDOWN_SCORER_4TH",
  TOUCHDOWN_SCORER_5TH: "TOUCHDOWN_SCORER_5TH",
  TOUCHDOWN_SCORER_6TH: "TOUCHDOWN_SCORER_6TH",
  TOUCHDOWN_SCORER_7TH: "TOUCHDOWN_SCORER_7TH",
  TOUCHDOWN_SCORER_8TH: "TOUCHDOWN_SCORER_8TH",
  TOUCHDOWN_SCORER_9TH: "TOUCHDOWN_SCORER_9TH",
  TOUCHDOWN_SCORER_10TH: "TOUCHDOWN_SCORER_10TH",
  PLAYER_TOUCHDOWN_2_PLUS: "PLAYER_TOUCHDOWN_2_PLUS",
  //
};

/**
 * Player Props Market Types
 */
export const playerPropsMarkets = [
  MarketTypes.PLAYER_TOTAL_RUSHING_YARDS_ROLLING,
  MarketTypes.PLAYER_TOTAL_RUSHING_ATTEMPTS_ROLLING,
  MarketTypes.PLAYER_TOTAL_RECEIVING_YARDS_ROLLING,
  MarketTypes.PLAYER_TOTAL_RECEPTIONS_ROLLING,
  MarketTypes.PLAYER_TOTAL_PASSING_YARDS_ROLLING,
  MarketTypes.PLAYER_TOTAL_PASSING_ATTEMPTS_ROLLING,
  MarketTypes.PLAYER_TOTAL_PASS_COMPLETIONS_ROLLING,
  MarketTypes.PLAYER_TOTAL_PASSING_TOUCHDOWNS_ROLLING,
  MarketTypes.PLAYER_TOTAL_POINTS_ROLLING,
  MarketTypes.PLAYER_TOTAL_ASSISTS_ROLLING,
  MarketTypes.PLAYER_TOTAL_BLOCKS_ROLLING,
  MarketTypes.PLAYER_TOTAL_REBOUNDS_ROLLING,
  MarketTypes.PLAYER_TOTAL_STEALS_ROLLING,
  // NHL
  MarketTypes.PLAYER_TOTAL_ASSISTS_ROLLING,
  MarketTypes.PLAYER_TOTAL_GOALS_ROLLING,
  MarketTypes.PLAYER_TOTAL_POINTS_ROLLING,
  MarketTypes.PLAYER_TOTAL_SHOTS_ROLLING,
];

/**
 * Runner side types
 * */
export const RunnerTypes = {
  HOME: "HOME",
  AWAY: "AWAY",
  NA: "NA",
  UNDER: "UNDER",
  OVER: "OVER",
  DRAW: "DRAW",
  TEAM1: "TEAM1",
  TEAM2: "TEAM2",
};

/**
 * Baseball phase types
 * */
export const BaseballPhaseTypes = {
  INNING_1_TOP: "INNING_1_TOP",
  INNING_1_BOTTOM: "INNING_1_BOTTOM",
  INNING_2_TOP: "INNING_2_TOP",
  INNING_2_BOTTOM: "INNING_2_BOTTOM",
  INNING_3_TOP: "INNING_3_TOP",
  INNING_3_BOTTOM: "INNING_3_BOTTOM",
  INNING_4_TOP: "INNING_4_TOP",
  INNING_4_BOTTOM: "INNING_4_BOTTOM",
  INNING_5_TOP: "INNING_5_TOP",
  INNING_5_BOTTOM: "INNING_5_BOTTOM",
  INNING_6_TOP: "INNING_6_TOP",
  INNING_6_BOTTOM: "INNING_6_BOTTOM",
  INNING_7_TOP: "INNING_7_TOP",
  INNING_7_BOTTOM: "INNING_7_BOTTOM",
  INNING_8_TOP: "INNING_8_TOP",
  INNING_8_BOTTOM: "INNING_8_BOTTOM",
  INNING_9_TOP: "INNING_9_TOP",
  INNING_9_BOTTOM: "INNING_9_BOTTOM",
  INNING_10_TOP: "INNING_10_TOP",
  INNING_10_BOTTOM: "INNING_10_BOTTOM",
};

/**
 * Boxing phase types
 * */
export const BoxingPhaseTypes = {
  "PRE-MATCH": "PRE_MATCH",
  ROUND_1: "ROUND_1",
  ROUND_2: "ROUND_1",
  ROUND_3: "ROUND_1",
  ROUND_4: "ROUND_1",
  ROUND_5: "ROUND_1",
  ROUND_6: "ROUND_1",
  ROUND_7: "ROUND_1",
  ROUND_8: "ROUND_1",
  ROUND_9: "ROUND_1",
  ROUND_10: "ROUND_1",
  ROUND_11: "ROUND_1",
  ROUND_12: "ROUND_1",
  "POST-MATCH": "POST_MATCH",
};

export const SessionStatus = {
  EXPIRED: "EXPIRED",
  FINISHED: "FINISHED",
  OPEN: "OPEN",
};
export const OpenBetsTypes = {
  STATEMENT: "STATEMENT",
  OPENBETS: "OPENBETS",
};
export const EventStatus = {
  OPEN: "OPEN",
  CLOSED: "CLOSED",
  GRADED: "GRADED",
  PAID: "PAID",
  SUSPENDED: "SUSPENDED",
};

/**
 * react-media breakpoints - mobile and desktop
 * adding tablet breakpoints as css only for the moment -
 * */
export const ResponsiveScreenSizes = {
  mobile: "767px",
  desktop: "768px",
  tabletLandscape: "1024px",
};
export const ResponsiveScreenSizesInt = {
  mobile: 767,
  desktop: 768,
  tabletLandscape: 1024,
};

/**
 *
 * filter tabs for competition
 * */
export const TabTypes = {
  LIVE: "LIVE",
  POPULAR: "POPULAR",
  ALL: "ALL",
} as const;

/**
 *
 * filter tabs for competition
 * */
export const MTSTabTypes = Object.freeze({
  POPULAR: "POPULAR",
  HANDICAP: "HANDICAP",
  GOALS: "GOALS",
  FIRSTHALF: "FIRST_HALF",
  FIFTEEN_MINUTES: "FIFTEEN_MINUTES",
  ALLMARKETS: "ALL_MARKETS",
});

/**
 *
 * breabcrumb menu type
 * */
export const MenuType = Object.freeze({
  SPORTS: "sports",
  COUNTRIES: "countries",
  COMPETITIONS: "competitions",
});

/**
 *
 * breabcrumb menu type
 * */
export const BetslipPanelTypes = Object.freeze({
  BETSLIP: "Bet Slip",
  OPENBETS: "Open Bets",
  OPENPOSITIONS: "Open Positions",
});

/**
 *
 * breabcrumb menu type
 * */
export const AsianBetslipPanelTypes = Object.freeze({
  SPORTS: "Sports",
  BETSLIP: "Bet Slip",
  OPENBETS: "Open Bets",
});

export const BetslipListTypes = Object.freeze({
  SINGLES: "SINGLES",
  MULTIPLES: "MULTIPLES",
});

/**
 *
 * reports menu type
 * */
export const ReportTypes = Object.freeze({
  CURRENT: "current",
  SETTLED: "settled",
  TRANSACTIONS: "transactions",
});

/**
 *
 * reports menu type
 * */
export const ReportBetTypes = Object.freeze({
  OPENBETS: "OPENBETS",
  STATEMENT: "STATEMENT",
});

/**
 * API polling intervals
 * */
export const PollingIntervals = Object.freeze({
  LIVE: 30000,
  DATE: 120000,
  ALL: 120000,
  POPULAR: 120000,
  EVENT: 60000,
  TIMEOUT: 60000,
  BETSLIPEVENT: 20000,
  NUMBER_OF_LIVE_EVENTS: 30000,
  BETSLIP_PRICE_POLLING: 20000,
  BETSLIP_PRICE_POLLING_FAST: 5000,
  MOBILE_EVENT_DETAILS: 30000,
  MOBILE_EVENT: 30000,
  WEBSOCKETPING: 5000,
  CRYPTOPENDING: 5000,
  BET_BUILDER_VALIDATION: 30000,
  OPEN_BETS_PANEL: 60000,
});

/**
 *
 * filter types for Asian competition
 * */
export const AsianCompetitionFilterTypes = Object.freeze({
  // ALPHABETICAL: "ALPHABETICAL",  in design but not implementing for now
  POPULARITY: "popularity",
  DATE: "date",
  LIVE: "live",
});

/**
 *
 * Asian report list types
 * */
export const AsianReportViewTypes = {
  SUMMARY: "SUMMARY",
  NORMAL: "NORMAL",
  LEAGUE: "LEAGUE",
  MATCH: "MATCH",
  EXCHANGE_BETTING: "EXCHANGE_BETTING",
  EXCHANGE_BETTING_BET: "EXCHANGE_BETTING_BET",
};

/**
 *
 * funding types
 * */
export const FundingTypes = {
  DEPOSIT: "DEPOSIT",
  WITHDRAWAL: "WITHDRAWAL",
};

export const CashierTransactionTypes = {
  DEPOSIT: "DEPOSIT",
  WITHDRAW: "WITHDRAW",
};

/**
 *
 * Accepted bankwire currencies
 * */
export const AcceptedBankwireCurrencies = ["EUR", "HKD", "AUD", "GBP", "USD"];

/**
 *
 * Odds types
 * */
export enum OddsType {
  DECIMAL = "DECIMAL",
  US = "US",
  HONG_KONG = "HONG_KONG",
  INDONESIAN = "INDONESIAN",
  MALAY = "MALAY",
  PROBABILITY = "PROBABILITY",
}

/**
 *
 * Odds types
 * */
export const OddsChangeType = {
  IMPROVED: "improved",
  SHORTENED: "shortened",
};

/**
 *
 * sports name types
 * */
export const SportsNameType = {
  SOCCER: "SOCCER",
  BASKETBALL: "BASKETBALL",
  BASEBALL: "BASEBALL",
  ESPORTS: "ESPORTS",
  ICE_HOCKEY: "ICE_HOCKEY",
  AMERICAN_FOOTBALL: "AMERICAN_FOOTBALL",
  TENNIS: "TENNIS",
  GOLF: "GOLF",
  BOXING: "BOXING",
  CRICKET: "CRICKET",
  MMA: "MMA",
};

/**
 *
 * screen types
 * */
export const ScreenType = {
  ASIAN: "ASIAN",
  EUROPEAN: "EUROPEAN",
};

/**
 *
 * Asian statement report list types
 * */
export enum AsianStatementTabTypes {
  ALL = "ALL",
  BETTING = "BETTING",
  FUNDING = "FUNDING",
}

/**
 *
 * Crypto Curreny Values
 * */
export const CryptoCurrencyTypes = {
  BTC: "BTC",
  BCH: "BCH",
  ETH: "ETH",
  USDT_ERC20: "USDT_ERC20",
  USDT_TRC20: "USDT_TRC20",
};

/**
 *
 * Competition list time types
 * */
export const competitionListTimeEnum = Object.freeze({
  TODAY: "TODAY",
  EARLY: "EARLY",
  ALL: "ALL",
});

/**
 *
 * Account Verification types
 * */
export const AccountVerificationTypes = Object.freeze({
  PHOTO_ID: "PHOTO_ID",
  ADDRESS: "ADDRESS",
  NOTE: "NOTE",
});
export const StatementPositiveBetStatuses = ["win", "win,push", "push,win"];
export const StatementNegativeBetStatuses = ["lose", "lose,push", "push,lose"];

/**
 * Site key for google recaptcha
 * Prod: for use in production
 * Dev: allows localhost, does not verify user
 * */
export const recaptchaSitekey = {
  prod: "6LcLHDoUAAAAAOozd_D1zYQIfPQgNkhyJpjsMb70",
  dev: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
};
export const GTM_ID = "GTM-WDZGPZ2";

export const onextwoSports = ["SOCCER", "CRICKET"];

// Sport names are returned from this endpoint: api3/asian/sportsNumberOFEvents
export const moneylineSports: Array<string> = [
  "Ice Hockey",
  "Tennis",
  "American Football",
  "Baseball",
  "MMA",
];
export const maxNumberOfBetsInBetslip = 15 as const;

/**
 * Maximum time in seconds between polls of the competitions list.
 * When an event goes live, if the time since the last poll of the
 * competition list is greater than eventGoneLiveInterval, then
 * the competition list should be fetched, and competition poll restarted
 * BET-6899
 * */
export const eventGoneLiveInterval = 60;

/**
 *
 * List of sports that can go live, but live score is not available
 * */
export const liveSportsNoScore = ["TENNIS", "BOXING"];

/**
 *
 * List of statuses for a runner
 * A CLOSED runner with no bets on it will go to GRADED
 * A CLOSED runner with bets will be set to CLOSED until it is graded, then it goes to GRADED
 *
 * */
export const RunnerStatus = Object.freeze({
  OPEN: "OPEN",
  CLOSED: "CLOSED",
  SUSPENDED: "SUSPENDED",
  GRADED: "GRADED",
});

/**
 *
 * List of statuses for a betslip
 * */
export const BetslipStatus = Object.freeze({
  OPEN: "OPEN",
  CLOSED: "CLOSED",
  SUSPENDED: "SUSPENDED",
  PAID: "PAID",
  GRADED: "GRADED",
});

/**
 *
 * List of statuses for a market
 * */
export const MarketStatus = Object.freeze({
  OPEN: "OPEN",
  CLOSED: "CLOSED",
  SUSPENDED: "SUSPENDED",
  PAID: "PAID",
  GRADED: "GRADED",
});

/**
 *
 * List of exchange sides
 * */
export const ExchangeRunnerPriceSides = Object.freeze({
  BACK: "BACK",
  LAY: "LAY",
  BLANK: "BLANK",
  UP: "up",
  DOWN: "down",
});

/**
 *
 * Profile screen
 * */
export const ProfileScreenTabs = {
  PERSONAL_DETAILS: "personal details",
  SECURITY: "security",
  PREFERENCES: "preferences",
};

export const ListRenderValues = Object.freeze({
  THRESHOLD: 30,
});

/**
 *
 * List of market types that are shown in the Alternative Lines section
 * */
export const AlternativeLinesMarketTypes = ["HANDICAP", "TOTAL"];

/**
 *
 * List of market types that are shown in the Alternative Lines section
 * */
export const FuturesAlternativeLinesMarketTypes = ["OUTRIGHT"];

export const freeWithdrawalTurnoverLimitUSD = "$250,000.00";

export const OpenBetsPanelPerPage = 15;
export const DEFAULT_OPEN_BETS_SIZE = 15;

export const MAX_WEBSOCKET_MESSAGE_SIZE = 8000;

/**
 *
 * Time in mS to wait before starting the speed check,
 * to prevent warning showing before app has fully started
 * */
export const startSpeedCheckDelay = 10000;

/**
 * Languages that are supported in the UI
 * locale: 2 parts, language and optional region eg "en": english, "zh-CN" Simplified Chinese as used in China
 * {language}-{REGION}
 * language: language name in english
 * label: Shown in the dropdowns, always in its own language, so a speaker of that language can recognise it
 * shortLabel: Two letter, eg : EN
 * active: boolean to show or not show the language in the list of languages
 * flag: Check https://github.com/madebybowtie/FlagKit/blob/master/Assets/Flags.md to get code
 * Link to download the svg: https://github.com/madebybowtie/FlagKit/tree/master/Assets/SVG
 * bundle: which language JSON to use
 * */
export const SUPPORTEDLANGUAGES = [
  {
    locale: "en",
    language: "English",
    label: "English",
    shortLabel: "EN",
    flag: "GB",
    active: true,
    bundle: "en",
  },
  {
    locale: "es-ES",
    language: "Spanish (Spain)",
    label: "Español",
    shortLabel: "ES",
    active: true,
    flag: "ES",
    bundle: "es-ES",
  },
  {
    locale: "pt-PT",
    language: "Portuguese (Portugal)",
    label: "Português",
    shortLabel: "PT",
    active: true,
    flag: "PT",
    bundle: "pt-PT",
  },
  {
    locale: "pt-BR",
    language: "Portuguese (Brazil)",
    label: "Português",
    shortLabel: "PT",
    active: true,
    flag: "BR",
    bundle: "pt-PT",
  },
  {
    locale: "zh-CN",
    language: "Simplified Chinese",
    label: "中文",
    shortLabel: "中文",
    active: true,
    flag: "CN",
    bundle: "zh-CN",
  },
];
export const DEFAULTSELECTEDLANGUAGE = "en";

/**
 * public view
 * */
export const PublicViewInfoMessageTimeout = {
  infoMessageTimeout: 200,
};

/**
 * Live golf screen
 * */
export const LiveGolfStatus = {
  STARTED: "STARTED",
  FINISHED: "FINISHED",
};

/**
 * Cashier- crypto
 */
export const TransactionDetailsStatus = Object.freeze({
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
  NEW: "NEW",
  REJECT: "REJECT",
  PENDING_APPROVAL: "PENDING_APPROVAL",
});

/**
 *
 *
 */
export const PromoCategories = {
  Event: "event",
  Competition: "competition",
  Sport: "sport",
};

/**
 *
 * Euro orderBy options
 * */
export const EuroOrderByOptions = Object.freeze({
  ALPHABETICAL: "alphabetical",
  POPULARITY: "popularity",
  DATE: "date",
  LIVE: "live",
});
export const NarrowCurrencySymbolLocales = ["es-ES", "pt-PT", "pt-BR"];

export const registrationInputMaxLength = {
  usernameMaxLength: 20,
  passwordMaxLength: 128,
  // Password validation checks for max length of 50,
  //  so max length here needs to be greater than 50 to allow the validation to work.
  // Otherwise maxLength will silently truncate the password to 50 characters.
  // Dont think we need to set max length, because the validation should handle
  // that when the new registration form is done
  emailMaxLength: 40,
  personalDetailsMaxLength: 20,
  addressInputMaxLength: 60,
  otherReason: 70,
};

export const CMSLANGUAGEIDS = Object.freeze({
  production: {
    en: 1,
    "pt-PT": 10,
    "pt-BR": 7,
    "es-ES": 13,
    "zh-CN": 3,
  },
  development: {
    en: 1,
    "zh-CN": 3,
    "pt-PT": 5,
    "pt-BR": 6,
    "es-ES": 7,
  },
});

export const geniusGametrackerSports = [
  SportsNameType.SOCCER,
  SportsNameType.TENNIS,
  SportsNameType.BASKETBALL,
  SportsNameType.AMERICAN_FOOTBALL,
];

export const geniusScoreboardSports = [
  SportsNameType.BASEBALL,
  SportsNameType.ICE_HOCKEY,
];

export const widgetProviders = {
  BETRADAR: "Betradar",
  GENIUSSPORTS: "Genius Sports",
};

export const NuveiTransactionStatus = {
  DECLINED: "DECLINED",
  APPROVED: "APPROVED",
  PENDING: "PENDING",
  ERROR: "ERROR",
  SUCCESS: "SUCCESS",
};

export const NuveiPaymentMethods = {
  CREDIT_CARD: "cc_card",
  INTERAC_E_TRANSFER: "apmgw_Interac_eTransfer",
  APPLE_PAY: "ppp_ApplePay",
  GOOGLE_PAY: "ppp_GooglePay",
};

export const NuveiOpenOrderPaymentMethods = {
  NUVEI: "nuvei",
  INTERAC: "interac",
  APPLE_PAY: "apple_pay",
  GOOGLE_PAY: "google_pay",
};

export const DocumentsForUpload: { [key: string]: string } = {
  PASSPORT: "Passport",
  DRIVING_LICENCE: "Full Driving License",
  ID_CARD_FRONT: "National Identity Card - Front",
  ID_CARD_BACK: "National Identity Card - Back",
  POA: "Proof of Address",
} as const;

export const DocumentCategory: { [key: string]: string } = {
  IDENTITY: "Identity",
  PROOFOFADDRESS: "Proof of Address",
} as const;

export const GeniusTagScript = {
  scriptUrl: "https://zz.connextra.com/dcs/tagController/tag/5750f979195a/",
};
export const verificationDocumentMaxFileSizeMb = 10 as const; //10Mb

// Using name BetFormats instead of BetType to avoid confusion with BetType Type
// eg of what is returned from the API: betType :  "Bet Builder"
export const BetFormats = {
  MULTIPLIER: "Multiplier",
  BET_BUILDER: "Bet Builder",
} as const;

// Password must be 8-128 characters long and contain at least 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character
export const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>])[A-Za-z\d!@#$%^&*(),.?":{}|<>]{8,128}$/;

// select screen types for user registration form modal
export const RegistrationFormScreens = {
  ACCOUNT_DETAILS: "account-details",
  PERSONAL_DETAILS: "personal-details",
  ACCOUNT_SETTINGS: "account-settings",
};

export const RegistrationFormModalFieldNames: {
  [K in keyof RegistrationData]: K;
} = {
  username: "username",
  email: "email",
  password: "password",
  firstName: "firstName",
  lastName: "lastName",
  dateOfBirth: "dateOfBirth",
  gender: "gender",
  country: "country",
  state: "state",
  address: "address",
  postCode: "postCode",
  phoneNumberPrefix: "phoneNumberPrefix",
  phoneNumberSuffix: "phoneNumberSuffix",
  currency: "currency",
  heardAboutUs: "heardAboutUs",
  promoCode: "promoCode",
  consentToMarketing: "consentToMarketing",
  consentToTerms: "consentToTerms",
  contactNumber: "contactNumber",
  addressLine1: "addressLine1",
  gRecaptchaResponse: "gRecaptchaResponse",
  acceptedTCs: "acceptedTCs",
};

// Enum for loss limit keys based on days
export enum LossLimitDays {
  ONE_DAY = "lossLimitOneDay",
  SEVEN_DAYS = "lossLimitSevenDays",
  THIRTY_DAYS = "lossLimitThirtyDays",
}

// Separate object for other loss limit-related keys
export const LossLimitKeys = {
  LOSS_LIMITS: "lossLimits",
  LIMIT_AMOUNT: "limitAmount",
};

// consts for Promopage, here we use api tokens from contentful
export const PromoPage = {
  CONTENTFUL_SPACE_ID: "14gcdxhsnuys",
  CONTENTFUL_ACCESS_TOKEN: "d99b0oYy6ZMRXfhIhzQAqgWYWgnMVDBfSrUo6LCmoHA",
  CONTENTFUL_ENTRY_ID: "vxtryAu8bbtJwK3mpVp7b",
  CONTENTFUL_ENVIRONMENT_STAGING: "staging",
  CONTENTFUL_ENVIRONMENT_MASTER: "master",
} as const;

// consts for Promopage, here we use api tokens from contentful
export const landingPage = {
  CONTENTFUL_SPACE_ID: "14gcdxhsnuys",
  CONTENTFUL_ACCESS_TOKEN: "R0jqSmRDAydjd4nG9dDRtlVR_ViJw3Pbg9Yq-XBbzD0",
  CONTENTFUL_ENTRY_ID: "2zf3lO9vcKjZDYz50RHLQH",
  CONTENTFUL_ENVIRONMENT_STAGING: "staging",
  CONTENTFUL_ENVIRONMENT_MASTER: "master",
} as const;

export const CompetitionFilterTypes = {
  ALL: "all",
  POPULAR: "popular",
  LIVE: "live",
} as const;

export type CompetitionFilterType =
  (typeof CompetitionFilterTypes)[keyof typeof CompetitionFilterTypes];

/*
 * Used to detect direct navigation (e.g., via link or bookmark).
 * If the browser's history length is less than or equal to this value,
 * we assume the user did not navigate through the app's navigation flow.
 */
export const DEFAULT_HISTORY_LENGTH_WHEN_NOT_NAVIGATED = 2;
